/* Shopify Forms in die Gestaltung des Shops holen.
 *
 * Die App liefert ihr Formular als Web-Komponente <form-embed> in einem Shadow
 * DOM aus. Das Stylesheet des Themes dringt dort nicht hinein -- deshalb steht
 * das Formular in fremder Schrift auf der Seite, egal was in der App
 * eingestellt ist. Hier werden die Regeln in die Kapsel hineingereicht.
 *
 * Angesprochen werden nur Elementnamen, keine Klassen der App: Klassennamen
 * aendern sich beim naechsten Update, <input> und <button> nicht.
 *
 * Eigene Schriftnamen stehen hier bewusst nicht. --font-body--family und
 * --font-heading--family sind CSS-Variablen des Themes, und Variablen gelten
 * auch innerhalb eines Shadow DOM weiter. Aendert sich die Schrift im Theme,
 * wandert das Formular von allein mit.
 */
(() => {
  const REGELN = `
    * { font-family: var(--font-body--family, inherit) !important; }

    /* Der komplette h3-Satz des Themes -- dieselbe Stufe wie "So läuft es ab"
       im Kasten daneben. Nicht nur die Groesse, sondern auch Gewicht,
       Zeilenhoehe und Laufweite, sonst sitzt es trotz gleicher Groesse anders. */
    h1, h2, h3, h4 {
      font-family: var(--font-h3--family, inherit) !important;
      font-weight: var(--font-h3--weight, 900) !important;
      font-size: var(--font-h3--size, inherit) !important;
      line-height: var(--font-h3--line-height, 1.2) !important;
      letter-spacing: var(--font-h3--letter-spacing, -.02em) !important;
    }

    /* Die App setzt im Formular alles fett -- Zwischentext, Beschriftungen,
       Platzhalter. Hier zurueck auf die normale Staerke des Shops. */
    p, span, label, li, div, input, textarea, select, a { font-weight: 400 !important; }
    ::placeholder { font-weight: 400 !important; opacity: .65; }
    strong, b { font-weight: 700 !important; }

    input, textarea, select {
      color: #0a1b4d;
      background: #ffffff;
      border: 1px solid rgba(128, 216, 248, .55);
      border-radius: 8px;
    }

    /* Unsere Schaltflaechen stehen auf einem harten Schatten, der beim Klicken
       einsinkt -- dieselbe Bewegung wie ueberall sonst im Shop. */
    button, [type="submit"] {
      font-weight: 700 !important;
      letter-spacing: .04em;
      border-radius: 8px;
      box-shadow: 0 6px 0 0 #0a1b4d;
      transition: transform .12s ease, box-shadow .12s ease;
    }
    button:hover, [type="submit"]:hover {
      transform: translateY(3px);
      box-shadow: 0 3px 0 0 #0a1b4d;
    }
    button:active, [type="submit"]:active {
      transform: translateY(6px);
      box-shadow: 0 0 0 0 #0a1b4d;
    }
  `;

  /* Nur die Kapseln des Formulars, nicht jede auf der Seite.

     Vorher ging es ueber alle Shadow-Wurzeln des Dokuments -- und damit auch
     ueber Shopifys eigene Konto-Komponente. Deren Knopf bekam so den harten
     Schatten unserer Schaltflaechen: im Kopfbereich stand ein dunkler Klecks
     unter dem Konto-Symbol. */
  const WIRT = "shopify-forms-embed";

  /* Die App verschachtelt Komponenten; jede bringt ihre eigene Kapsel mit. */
  function kapseln(wurzel, gefunden = []) {
    for (const el of wurzel.querySelectorAll("*")) {
      if (el.shadowRoot) {
        gefunden.push(el.shadowRoot);
        kapseln(el.shadowRoot, gefunden);
      }
    }
    return gefunden;
  }

  /* Der Rechtshinweis unter dem Absenden-Knopf kommt mit 10 px aus der App.
     Das ist zu klein zum Lesen; die Groesse steht nicht in ihren
     Einstellungen, also wird sie hier angehoben. */
  function kleingedrucktes(kapsel) {
    for (const el of kapsel.querySelectorAll("p, span, small")) {
      if (el.children.length || el.dataset.fafGross) continue;
      if (parseFloat(getComputedStyle(el).fontSize) >= 12) continue;
      el.dataset.fafGross = "";
      el.style.fontSize = "12px";
      el.style.lineHeight = "1.5";
    }
  }

  function anwenden() {
    for (const wirt of document.querySelectorAll(WIRT)) {
      if (!wirt.shadowRoot) continue;
      for (const kapsel of [wirt.shadowRoot, ...kapseln(wirt.shadowRoot)]) {
        if (!kapsel.querySelector("style[data-faf]")) {
          const stil = document.createElement("style");
          stil.dataset.faf = "";
          stil.textContent = REGELN;
          kapsel.appendChild(stil);
        }
        kleingedrucktes(kapsel);
      }
    }
  }

  /* Das Formular wird nachgeladen, oft erst nach dem ersten Zeichnen.
     Der Beobachter wartet darauf, gebuendelt auf ein Einzelbild. */
  let geplant = false;
  function melden() {
    if (geplant) return;
    geplant = true;
    requestAnimationFrame(() => { geplant = false; anwenden(); });
  }

  anwenden();
  new MutationObserver(melden).observe(document.documentElement,
    { childList: true, subtree: true });
})();
